import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { BasicDialogComponent } from '../../../shared/components/basic-dialog/basic-dialog.component';
import { SimpleDialog } from '../../../shared/models/simple-dialog';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const dialog = inject(MatDialog);

  const sessionExpiredDialog: SimpleDialog = {
    uiTitle: 'Your session has expired',
    uiMessage:
      "To continue, please click 'OK' to be redirected to the login page.",
    redirect: '/auth/logout',
  };

  // Show the "session expired" dialog instead of silently redirecting. The
  // dialog's OK button handles the redirect to the login flow.
  const blockWithDialog = (): boolean => {
    if (dialog.openDialogs.length === 0) {
      dialog.open(BasicDialogComponent, { data: sessionExpiredDialog });
    }
    return false;
  };

  // Quick synchronous check of localStorage
  const storedAuth = authService.getAuthFromLocalStorage();

  if (storedAuth && storedAuth.session) {
    // User has stored session, allow access
    return true;
  }

  // If local storage is empty, verify whether Amplify still has a valid session.
  return authService.getUserBySession().pipe(
    map((session) => {
      if (session && session.session) {
        return true;
      }

      return blockWithDialog();
    }),
    catchError(() => of(blockWithDialog())),
  );
};
